import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { TableTextCell } from '../../../Table'
import { DocFlowTableCellInfoIcon } from '../DocFlowTableCellInfoIcon'

import * as styles from './DocFlowTableCellPagesRange.module.css'

function DocFlowTableCellPagesRange({ className, value, ...restProps }) {
  const { t } = useTranslation()

  const cellClassName = classNames(className, styles.cell)

  const cellvalue = value?.join('-')

  return (
    <TableTextCell {...restProps} className={cellClassName} value={cellvalue}>
      <DocFlowTableCellInfoIcon
        content={t('DocumentStapling.MappingResultageNumbersTooltipKey')}
      />
    </TableTextCell>
  )
}

export default DocFlowTableCellPagesRange
